import { CommonModule } from '@angular/common';
import { Component,  Input } from '@angular/core';

@Component({
    selector: 'big-and-grey',
    template: `
<div class="big-holder">
  <div class="big-title" [ngStyle]="{'font-weight': boldTitle ? 'bold' : 'normal'}">{{ theTitle }}</div>
  <div class="big-grey">{{ greyText }}</div>
</div>
`,
    styles: [`
  :host {display: block;  overflow: hidden;}
  .big-holder { display: flex; flex-direction: column; }
  .big-title { font-size: 14px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; }
  .big-grey { font-size: 12px; color: rgba(0,0,0,0.4); }
`],
    standalone: true,
    imports: [CommonModule],
})

export class BigAndGreyComponent {
  @Input() theTitle = '' // The name
  @Input() greyText
  @Input() boldTitle = true
}
